import { broadcastLogout } from './logoutSync';

/**
 * Client-side cleanup shared by every logout path (explicit logout, account
 * deletion): clear per-user preferences so the next user on this browser
 * doesn't inherit theme, layout, dismissed notices, etc., and tell other open
 * tabs to redirect to the login page.
 */
export function clearClientSession(): void {
  localStorage.removeItem('ipt:preferences');
  broadcastLogout();
}

/**
 * Utility function to handle user logout via POST request
 * This avoids putting form_key in the URL for better security
 */
export function handleLogout(formKey: string): void {
  clearClientSession();

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/user/logout';

  const formKeyInput = document.createElement('input');
  formKeyInput.type = 'hidden';
  formKeyInput.name = 'form_key';
  formKeyInput.value = formKey;
  form.appendChild(formKeyInput);

  document.body.appendChild(form);
  form.submit();
}
